import { call, put, takeLatest } from 'redux-saga/effects'

import * as api from '../api'
import {
  loginRequest,
  loginSuccess,
  loginFailure,
  loginFulfill,
  logoutRequest,
  logoutSuccess,
  logoutFailure,
  logoutFulfill,
  LoginTriggerAction,
  LogoutTriggerAction,
  ForgotTriggerAction,
  forgotSuccess,
  forgotError,
  LoginResponse,
  UserTypes,
  twoFactRequest,
  twoFactSuccess,
  twoFactFailure,
  twoFactFulfill,
  TwoFactResponse,
  TwoFactTriggerAction,

} from '../actions'
import { get } from 'lodash'
import { storageRemoveItem, storageSetItem } from '../components/common/Cookie'

export function* doLogIn(action: LoginTriggerAction): Generator {
  try {
    yield put(loginRequest())
    const userData: LoginResponse = yield call(api.login, action.payload)

    if (userData.success) {
      yield put(loginSuccess(userData))
      if (get(userData, 'two_fact_auth')) {
        let loginData = get(userData, 'loginData')
        if (loginData) {
          storageSetItem('loginData', loginData)
        }
        action.meta.push('/2fa')
      } else {
        action.meta.push('/dashboard')
      }
    }
  } catch (err) {
    if (err._code === 401) {
      let msg = { message: 'Login Failed' }
      yield put(loginFailure(msg))
    } else {
      yield put(loginFailure(err))
    }
  } finally {
    yield put(loginFulfill())
  }
}

export function* doTwoFactIn(action: TwoFactTriggerAction): Generator {
  try {
    yield put(twoFactRequest())
    const userData: TwoFactResponse = yield call(api.twofactlogin, action.payload)

    if (userData.success) {
      yield put(twoFactSuccess(userData))
      window.location.href = '/dashboard'
      // action.meta.push('/dashboard')
    }
  } catch (err) {
    if (err._code === 401) {
      let msg = { message: 'Invalid Code' }
      yield put(twoFactFailure(msg))
    } else {
      yield put(twoFactFailure(err))
    }
  } finally {
    yield put(twoFactFulfill())
  }
}

export function* doLogOut(action: LogoutTriggerAction): Generator {
  try {
    yield put(logoutRequest())
    yield call(api.logout)
    yield put(logoutSuccess())
  } catch (err) {
    yield put(logoutFailure(err))
  } finally {
    storageRemoveItem('loginData')
    yield put(logoutFulfill())
  }
}

/**
 * Trigger the Forgot API Fecth
 */
export function* doForgot(action: ForgotTriggerAction): Generator {

  /**
   *   Connects to forgot function on api/index.ts
   *   send the email address as payload
   *
   *   @Error - Trigger forgotError action to send the error state
   *   @Finally - Trigger forgotSuccess action to send the forgot success message
   */
  try {
    const resp = yield call(api.forgot, action.payload)

    if (resp) {
      yield put(forgotSuccess())
    }

  } catch (err) {
    yield put(forgotError())
  }

}

export const userSaga = [
  takeLatest(UserTypes.LOGIN_TRIGGER, doLogIn),
  takeLatest(UserTypes.TWO_FACT_TRIGGER, doTwoFactIn),
  takeLatest(UserTypes.LOGOUT_TRIGGER, doLogOut),
  takeLatest(UserTypes.FORGOT_TRIGGER, doForgot),
]


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/sagas/user.ts